<template>
  <div>
    <TopBar currentTitle="Ingredient Aisles">
      <b-button type="is-primary" size="is-small" icon-left="plus" @click="createNew">Add Aisle</b-button>
    </TopBar>
    <div class="page-content">
    <h1 class="page-title">Ingredient Aisles</h1>
    <p class="page-subtitle mb-4">{{ aisles.length }} total</p>

    <!-- Table Card -->
    <div class="feeds-card">
      <div class="feeds-card-body compact">
        <b-table
          :data="aisles"
          :hoverable="true"
          @click="open">

          <b-table-column field="name" label="Name" sortable v-slot="props">
            <p class="has-text-weight-bold">{{ props.row.name }}</p>
          </b-table-column>

          <b-table-column field="position" label="Position" centered v-slot="props">
            {{ props.row.position }}
          </b-table-column>

          <b-table-column field="created_at" width=100 label="Created" sortable centered v-slot="props">
            <span class="date-tag">{{ new Date(props.row.created_at).toLocaleDateString() }}</span>
          </b-table-column>

          <b-table-column field="delete" custom-key="actions" width=40 centered v-slot="props">
            <b-button type="is-danger" size="is-small" icon-right="delete" @click.stop="deleteItem(props.row)" />
          </b-table-column>
        </b-table>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/db"
import TopBar from '@/components/layout/TopBar.vue'

const SCROLL_STATE_KEY = 'feeds_list_state_IngredientAisleListView'

export default {
  name: 'IngredientAisleListView',
  components: {
    TopBar
  },
  data() {
    return {
      aisles: [],
      scrollRestored: false
    }
  },
  watch: {
    aisles() {
      if (!this.scrollRestored) {
        this.scrollRestored = true
        this.$nextTick(() => {
          const savedState = sessionStorage.getItem(SCROLL_STATE_KEY)
          if (savedState) {
            const state = JSON.parse(savedState)
            if (state.scrollY > 0) {
              setTimeout(() => window.scrollTo(state.scrollX, state.scrollY), 50)
            }
          }
        })
      }
    }
  },
  firestore: {
    aisles: db.collection('ingredient_aisles').orderBy("position", "asc")
  },
  methods: {
    createNew() {
      db.collection("ingredient_aisles").add({
        created_at: Date.now(),
        name: null,
        position: null
      })
      .then((docRef) => {
        this.$router.push({ name: 'IngredientAisleView', params: { id: docRef.id } })
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
    },
    open(aisle) {
      this.$router.push({ name: 'IngredientAisleView', params: { id: aisle.id } })
    },
    deleteItem(aisle) {
      this.$buefy.dialog.confirm({
        title: 'Deleting ingredient aisle',
        message: `Are you sure you want to delete ingredient aisle: <b><i>"${aisle.name}"</i></b>? <br /><br />This action cannot be undone.`,
        confirmText: 'Delete Aisle',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          db.collection("ingredient_aisles").doc(aisle.id)
          .delete()
          .then(() => {
            this.$buefy.toast.open({type: 'is-success', message: `Ingredient aisle successfully deleted!`})
          }).catch((error) => {
            this.$buefy.toast.open({type: 'is-danger', message: `Error deleting ingredient aisle: ${error}`})
          });
        }
      })
    }
  }
}
</script>

<style scoped>
.date-tag {
  font-size: 12px;
  color: var(--text-secondary);
}
</style>
